<label>{{ title }}</label>
<span class="row chips-container">
  <app-kp-autocomplete
    [filterFunction]="this.filterFn.bind(this)"
    [placeholder]="'Search...'"
    [disabled]="disabled"
    [clearOnSelection]="true"
    [position]="'fixed'"
    [inputWidth]="'369px'"
    [matTooltip]="tooltip"
    matTooltipShowDelay="500"
    matTooltipPosition="above"
    (selectedChange)="onSelectFilterItem($event)"
    >
  </app-kp-autocomplete>
  @for (item of selectedFilterItems; track item.id) {
    <button class="chip">
      {{ item.name }}
      <mat-icon
        class="remove-chip"
        matTooltip="Remove {{ item.name }}"
        matTooltipShowDelay="500"
        (click)="onRemoveFilterItem(item.id)"
        fontIcon="close"
      ></mat-icon>
    </button>
  }
</span>
